export default "__VITE_ASSET__b78bb672__"